let STOP = 3;
let calledCount = localStorage.getItem('entryPopUpCount') || 0;
const templateUrl = require('./../views/partials/entrypopup.html');

function entryPopupDirective($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {},
    replace: true,
    templateUrl,
    link: function(scope, el, attrs) {

      scope.showPopup = false;

      if(calledCount < STOP) {
        window.scroll(0, 0);
        $('body').addClass('stop-scrolling');
        $timeout(() => {
          scope.showPopup = true;
          calledCount++;
          localStorage.setItem('entryPopUpCount', calledCount);
        }, 450);
      }

      $('.ep-EntryPopUp_Close').on('click', function() {
        $('body').removeClass('stop-scrolling');
      });

      $('.stop-showing').on('click', function() {
        calledCount = 7;
        localStorage.setItem('entryPopUpCount', calledCount);
        $('body').removeClass('stop-scrolling');
      });
    }
  };
}

export default entryPopupDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/entryPopup.js